import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MobileMenuStep from '../../../../Shared/Components/MobileMenuStep';
import { TicBigIcon, CloseMenuIcon } from '../../../../../Icons';

const useStyles = makeStyles(
  (theme) => ({
    overviewList: {
      padding: 0,
      margin: theme.spacing(3),
      '& .MuiListItem-root': {
        backgroundColor: theme.layout.list.backgroundColor,
        height: theme.layout.appbar.heightSm,
        padding: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.backgroundColor}`,
        '&.active': {
          background: theme.layout.list.backgroundColorSelected,
        },
      },
    },
    detailList: {
      padding: 0,
      margin: theme.spacing(3),
    },
  }),
  { name: 'MobilePickerMenu' },
);

const MobilePickerMenu = ({
  doDisplay, designedAreas,
  closeMobilePickerMenu, filteredDesignAreas, setModalContentOption,
  openDesignArea, handleChangeDesignArea, closeDesignArea, modalContentOptions, currentModalContentOption,
}) => {
  const classes = useStyles();
  const renderStep = () => (
    <List
      classes={
           { root: classes.overviewList }
            }
      disablePadding
    >
      {filteredDesignAreas.map((option) => (
        <ListItem
          className={designedAreas[option.identifier] ? 'active' : ''}
          key={option.identifier}
          disableGutters
          button
          onClick={() => {
            setModalContentOption(modalContentOptions.RENDER_ITEMMENU);
            openDesignArea();
            handleChangeDesignArea(option.identifier);
          }}
        >
          <ListItemText primary={option.title} />
          {designedAreas[option.identifier] && (
          <>
            <TicBigIcon />
          </>
          )}
        </ListItem>
      ))}
    </List>
  );
  return (
    <MobileMenuStep
      doDisplay={doDisplay && currentModalContentOption === modalContentOptions.RENDER_OVERVIEW}
      renderStep={renderStep}
      heading={t('configurationPicker.designerBtn')}
      backFunc={null}
      closeFunc={() => {
        setModalContentOption(null);
        closeMobilePickerMenu();
      }}
      doDisplayDesignArea={false}
    />
  );
};

MobilePickerMenu.defaultProps = {
};

MobilePickerMenu.propTypes = {
};

export default MobilePickerMenu;
